export default __webpack_public_path__ + "static/media/header-logo.cad227b2.svg";